import React from 'react';
import {Col, Container, Row, Card, CardBody} from 'reactstrap';
import {connect} from 'react-redux';
import LoadingProgress from '../../components/LoadingProgress'
import ReactQueryParams from 'react-query-params';
import {ButtonToolbar} from 'reactstrap';
import {fetchAdminDataIfNeeded} from '../../redux/actions/AdminActions';
import {withRouter} from 'react-router-dom';
import Alert from '../../components/Alert';
//import FilterSelector from './components/FilterSelector'
import * as TextManager from "../../modules/languages/TextManager";
//import StatusSelector from './components/StatusSelector'
import StoreTable from './components/StoresTable'
import ManagerTable from './components/ManagersTable'

export class Settings extends ReactQueryParams {

    componentDidMount() {

        this.props.dispatch(fetchAdminDataIfNeeded(this.queryParams));
    }

    render() {

        return (
            <Container className='dashboard'>

                { this.props.status === 'request' &&
                <Row>
                    <LoadingProgress/>
                </Row>
                }

                { this.props.status === 'error' &&
                <Row>
                    <Alert color='danger' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.error}</span></p>
                        <p>{TextManager.getCurrentTextResource().Text.unexpectedServerError}</p>
                    </Alert>
                </Row>
                }

                { this.props.status === 'no_permission' &&
                <Row>
                    <Alert color='warning' className='alert--bordered' icon>
                        <p><span className='bold-text'>{TextManager.getCurrentTextResource().Text.loginFailed}</span>
                            {TextManager.getCurrentTextResource().Text.pleaseRefreshThePage}</p>
                    </Alert>
                </Row>
                }

                { this.props.status === 'success' &&
                <span>
                    <Row>
                      <Col md={12}>
                        <Card>
                            <CardBody style={{padding: "1.25rem"}}>
                                <h3 style={{textAlign: 'right'}}>{TextManager.getCurrentTextResource().Settings.settings}</h3>
                                <div style={{position: 'absolute', display: 'flex', height: '100%', width: '50%'}}>
                                  <ButtonToolbar className='custom_dashboard_header_panel'>
                                      {/*<FilterSelector endpoint="products" name={TextManager.getCurrentTextResource().Customers.provider} queryParam="provider"/>
                                      <FilterSelector endpoint="platforms" name={TextManager.getCurrentTextResource().Customers.city} queryParam="city"/>*/}
                                  </ButtonToolbar>
                                </div>
                            </CardBody>
                        </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} xl={8} lg={12} xs={12}>
                            <StoreTable/>
                        </Col>
                        <Col md={12} xl={4} lg={12} xs={12}>
                            <ManagerTable/>
                        </Col>
                    </Row>
                </span>
                }

            </Container>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        status: state.admin.status,
        stores: state.admin.stores,
        managers: state.admin.managers,
        userData:state.userData
    };
};

export default withRouter(connect(mapStateToProps)(Settings))